<template>
  <div>
    <!-- Naslov vise ne ide ovdje: kartica koja ovu komponentu sadrzi
         (DocumentView3) ima vlastiti naslov, pa se "Financijski podaci"
         ispisivalo dvaput. -->
      <v-row no-gutters>
        <v-col cols="4">                   
          {{lang.BankName}}
        </v-col>
        <v-col cols="8">
            <span style="font-weight:bold">{{document.bankAccountName}}, {{document.bankAccountId}}</span>
        </v-col>
      </v-row>

      <v-layout row >
        <v-col cols="4">
          {{lang.IBAN}}
        </v-col>
        <v-col cols="8">
            <span style="font-weight:bold">{{document.bankAccountNr}}</span>
        </v-col>
      </v-layout>

    <v-divider></v-divider>

        <!-- Obracun naloga. Prije je ovdje bio raspored iz Vuetifyja 1
             ("v-flex xs5", "text-xs-right") unutar "v-row" iz Vuetifyja 2, pa
             sirine i poravnanje nisu radili: naslov je prelazio u dva reda, a
             iznos se lomio nasred broja ("-4.439,1" pa "0" u novi red).
             Sada je obican popis redaka: naziv lijevo, iznos desno. -->
        <div class="obracun">
          <div class="redak">
            <span class="opis">+ {{ this.$store.state.language === 'EN' ? 'To Invoicing' : 'Proizvedeno' }}</span>
            <span class="iznos">{{ localMoney(document.FreeF4) }}</span>
          </div>
          <div class="redak">
            <span class="opis">&minus; {{ this.$store.state.language === 'EN' ? 'Material cost' : 'Trošak materijala' }}</span>
            <span class="iznos">{{ localMoney(document.FreeF1) }}</span>
          </div>
          <div class="redak">
            <span class="opis">&minus; {{ this.$store.state.language === 'EN' ? 'Workers cost' : 'Trošak radnika' }}
              <span class="uz">{{ this.$store.state.language === 'EN' ? 'work hrs' : 'radni sati' }}: {{ localMoney(document.FreeF5) }}</span>
            </span>
            <span class="iznos">{{ localMoney(document.FreeF2) }}</span>
          </div>
          <div class="redak">
            <span class="opis">&minus; {{ this.$store.state.language === 'EN' ? 'Other costs' : 'Ostali troškovi' }}</span>
            <span class="iznos">{{ localMoney(document.FreeF3) }}</span>
          </div>

          <!-- Kostanje je zbroj triju troskova; prije se nije vidjelo nigdje,
               nego se moralo zbrajati u glavi. -->
          <div class="redak zbroj">
            <span class="opis">= {{ this.$store.state.language === 'EN' ? 'Total cost' : 'Koštanje ukupno' }}</span>
            <span class="iznos">{{ localMoney(kostanje) }}</span>
          </div>

          <div class="redak rezultat" :class="profitLoss >= 0 ? 'dobit' : 'gubitak'">
            <span class="opis">= {{ this.$store.state.language === 'EN' ? 'Profit/Loss' : 'Dobit/Gubitak' }}</span>
            <span class="iznos">{{ localMoney(profitLoss) }}</span>
          </div>
          <div class="redak ruc">
            <span class="opis">RUC %</span>
            <span class="iznos">{{ rucTekst }}</span>
          </div>
        </div>

    <v-divider></v-divider>

  </div>
</template>

<script>
import langEn from './documentDescEn'
import langHr from './documentDescHR'
import commEn from '@/language/commonEN'
import commHr from '@/language/commonHR'
import moneyFormat from '@/snippets/moneyFormat'

export default {
  computed: {
    // Zbroj triju troskova - materijal, rad i ostalo.
    kostanje () {
      const n = (v) => parseFloat(v) || 0
      const d = this.document || {}
      return n(d.FreeF1) + n(d.FreeF2) + n(d.FreeF3)
    },
    // RUC se racuna na kostanje, ista osnovica kao drugdje u programu.
    rucTekst () {
      if (this.kostanje <= 0) { return '–' }
      return this.localMoney(Math.round(this.profitLoss / this.kostanje * 10000) / 100) + ' %'
    }
  },
  data() {
    return {
      document: {},
      lang: {},
      langC: {},
      documentNameLoc: '',
      docSide: 3,
      profitLoss: 0,
      profitLossP: '',
    }
  },
  mounted() {
    if (this.$store.state.language === 'EN') {
      this.lang = langEn
      this.langC = commEn
    }
    if (this.$store.state.language === 'HR') {
      this.lang = langHr
      this.langC = commHr
    }
    if (this.$store.state.documentActivHead) {
      this.document = this.$store.state.documentActivHead
      this.documentNameLoc = this.$store.state.documentActivLoc
    }
     if (this.$store.state.documentSide) {
        this.docSide = this.$store.state.documentSide
      }
     this.profitLoss = (this.document.FreeF4 ? parseFloat(this.document.FreeF4) : 0) - (this.document.FreeF1 ? parseFloat(this.document.FreeF1) : 0) - (this.document.FreeF2 ? parseFloat(this.document.FreeF2) : 0) - (this.document.FreeF3 ? parseFloat(this.document.FreeF3) : 0)
  },
  methods: {
    localMoney(moneyToFormat) {
      return moneyFormat(moneyToFormat)
    },
  } 
}
</script>

<style scoped>
.obracun .redak {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  padding: 3px 0;
}
.obracun .opis { font-size: 13px; }
.obracun .opis .uz { font-size: 11px; color: rgba(0, 0, 0, 0.6); }
.obracun .iznos {
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  text-align: right;
  font-weight: 500;
}
.obracun .zbroj {
  border-top: 1px solid #e0e0e0;
  margin-top: 4px;
  padding-top: 6px;
}
.obracun .zbroj .opis, .obracun .zbroj .iznos { font-weight: 700; }
.obracun .rezultat {
  border-top: 2px solid #bdbdbd;
  margin-top: 6px;
  padding-top: 8px;
}
.obracun .rezultat .opis { font-size: 15px; font-weight: 700; }
.obracun .rezultat .iznos { font-size: 20px; font-weight: 700; }
.obracun .rezultat.dobit .iznos { color: #2e7d32; }
.obracun .rezultat.gubitak .iznos { color: #c62828; }
.obracun .ruc .opis, .obracun .ruc .iznos { font-size: 12px; color: rgba(0, 0, 0, 0.6); }
</style>
